(function () {
	document.querySelectorAll(".table-responsive").forEach((el) => {
		if (el.scrollWidth > el.clientWidth) {
			/**
			 * Create a container for our second scrollbar
			 * which will use the native scrollbar once the
			 * container overflows.
			 */
			const secondScrollbarEl = document.createElement("div");
			secondScrollbarEl.classList.add("psuedo-scrollbar__container");

			/**
			 * The filler element will be used to force the second scrollbar
			 * container to be the same width as the table.
			 */
			const fillerEl = document.createElement("div");
			fillerEl.classList.add("psuedo-scrollbar__filler");
			fillerEl.style.width = `${el.scrollWidth}px`;
			secondScrollbarEl.appendChild(fillerEl);

			el.parentNode.insertBefore(secondScrollbarEl, el);

			/**
			 * We need to bind the two scrollbars together so they
			 * function as one effective scrollbar.
			 */
			el.addEventListener("scroll", () => {
				secondScrollbarEl.scrollLeft = el.scrollLeft;
			});

			secondScrollbarEl.addEventListener("scroll", () => {
				el.scrollLeft = secondScrollbarEl.scrollLeft;
			});
		}
	});
})();
